var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bannerVideo"},[_c('div',{staticClass:"video"},[_c('video',{attrs:{"src":_vm.videoUrl,"muted":"muted","loop":"loop","autoplay":"autoplay","type":"video/mp4"},domProps:{"muted":true}})]),_c('div',{staticClass:"text-box"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }